import { render, staticRenderFns } from "./OneSpecification.vue?vue&type=template&id=7d50b6da&"
import script from "./OneSpecification.vue?vue&type=script&lang=js&"
export * from "./OneSpecification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports